import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from '../../shared/localization/i18n';
import secureStorage from '../services/secureStorage';
import encryptedSessionStorage from '../services/encryptedSessionStorage';

export const LANGUAGE_STORAGE_KEY = 'app_language';

// Synchronous read for Redux initialState — reads the raw value from sessionStorage.
// Legacy plaintext values are returned as-is; encrypted ciphertext will be null (→ default 'en').
// The AppNavigator bootstrap overwrites this with the fully-decrypted secureStorage value.
export function getPersistedLanguage(): string {
  try {
    const stored = encryptedSessionStorage.getItemSync(LANGUAGE_STORAGE_KEY);
    if (stored) {
      return stored;
    }
  } catch {
    // ignore
  }
  return 'en';
}

type LanguageState = {
  language: string;
};

const initialState: LanguageState = {
  language: getPersistedLanguage(),
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
      i18n.changeLanguage(action.payload);
      // Persist to secureStorage (encrypted IndexedDB) — no longer written to plaintext localStorage
      secureStorage.setItem(LANGUAGE_STORAGE_KEY, action.payload).catch(() => {});
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
